import { useEffect, useState } from "react";
import api, { fmtErr, inr, fmtDateTime } from "../../lib/api";
import { FullScreenLoader } from "../../context/AuthContext";
import { toast } from "sonner";

const STATUSES = ["", "ORDER_CREATED", "AWB_ASSIGNED", "PICKUP_SCHEDULED", "PICKED_UP", "IN_TRANSIT", "OUT_FOR_DELIVERY", "DELIVERED", "NDR", "RTO", "CANCELLED"];

export default function FranchiseShipments() {
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState("");

  useEffect(() => {
    setRows(null);
    api.get(`/franchise/shipments${status ? `?status=${status}` : ""}`)
      .then(({ data }) => setRows(data))
      .catch((e) => { toast.error(fmtErr(e)); setRows([]); });
  }, [status]);

  if (!rows) return <FullScreenLoader label="Loading shipments" />;

  return (
    <div className="space-y-5" data-testid="franchise-shipments-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-bold text-shipany-navy">Customer Shipments</h1>
          <p className="text-sm text-slate-500">All shipments booked by your customers.</p>
        </div>
        <select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="shipments-status-filter"
          className="rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-shipany-navy focus:border-shipany-blue focus:outline-none">
          {STATUSES.map((s) => <option key={s} value={s}>{s ? s.replace(/_/g, " ") : "All statuses"}</option>)}
        </select>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-sm">
        <table className="w-full min-w-[760px] text-sm">
          <thead>
            <tr className="border-b border-slate-100 text-left text-xs font-bold uppercase tracking-wide text-slate-400">
              <th className="px-5 py-3">AWB / Order</th><th className="px-5 py-3">Customer</th><th className="px-5 py-3">Courier</th>
              <th className="px-5 py-3">Route</th><th className="px-5 py-3 text-right">Price</th><th className="px-5 py-3">Status</th><th className="px-5 py-3">Booked</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((s) => (
              <tr key={s.shipment_id} className="border-b border-slate-50" data-testid={`franchise-shipment-${s.awb || s.order_number}`}>
                <td className="px-5 py-3.5"><p className="mono text-xs font-semibold text-shipany-navy">{s.awb || "—"}</p><p className="text-[10px] text-slate-400">{s.order_number}</p></td>
                <td className="px-5 py-3.5"><p className="text-xs font-semibold">{s.customer_name}</p><p className="text-[10px] text-slate-400">{s.customer_company}</p></td>
                <td className="px-5 py-3.5 text-xs">{s.courier_name}</td>
                <td className="px-5 py-3.5 text-xs">{s.origin_city} → {s.destination_city}</td>
                <td className="mono px-5 py-3.5 text-right text-xs font-semibold">{inr(s.price || 0)}</td>
                <td className="px-5 py-3.5"><span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-bold">{s.status}</span></td>
                <td className="px-5 py-3.5 text-xs text-slate-500">{fmtDateTime(s.created_at)}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7} className="px-5 py-10 text-center text-sm text-slate-400" data-testid="shipments-empty">No shipments found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
